import { ResetButton } from './ResetButton';
import { CloneButton } from './CloneButton';
import { SaveButton } from './SaveButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SaveViewButtonsPresentational = ({
  isReadOnlyView,
  isModifiedView,
  isCloningDisabled = false,
  onCloneClick,
  onResetClick,
  onSaveClick
}) => {
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "save-view-buttons",
    children: [/*#__PURE__*/_jsx(ResetButton, {
      isModifiedView: isModifiedView,
      onClick: onResetClick
    }), /*#__PURE__*/_jsx(CloneButton, {
      onClick: onCloneClick,
      isDisabled: isCloningDisabled
    }), /*#__PURE__*/_jsx(SaveButton, {
      isModifiedView: isModifiedView,
      isReadOnlyView: isReadOnlyView,
      onClick: onSaveClick
    })]
  });
};